import { Dispatch } from 'redux';
import axiosInstance from "../../axios";

// Action Types
export const WISHLIST_LIST_REQUEST = 'WISHLIST_LIST_REQUEST';
export const WISHLIST_LIST_SUCCESS = 'WISHLIST_LIST_SUCCESS';
export const WISHLIST_LIST_FAILURE = 'WISHLIST_LIST_FAILURE';
export const WISHLIST_ADD_REQUEST = 'WISHLIST_ADD_REQUEST';
export const WISHLIST_ADD_SUCCESS = 'WISHLIST_ADD_SUCCESS';
export const WISHLIST_ADD_FAILURE = 'WISHLIST_ADD_FAILURE';
export const WISHLIST_REMOVE_REQUEST = 'WISHLIST_REMOVE_REQUEST';
export const WISHLIST_REMOVE_SUCCESS = 'WISHLIST_REMOVE_SUCCESS';
export const WISHLIST_REMOVE_FAILURE = 'WISHLIST_REMOVE_FAILURE';
export const WISHLIST_CLEAR = 'WISHLIST_CLEAR';

// Action Creators
export const wishlistListRequest = () => ({
    type: WISHLIST_LIST_REQUEST,
});

export const wishlistListSuccess = (items) => ({
    type: WISHLIST_LIST_SUCCESS,
    payload: items,
});

export const wishlistListFailure = (error) => ({
    type: WISHLIST_LIST_FAILURE,
    payload: error,
});

export const wishlistAddRequest = () => ({
    type: WISHLIST_ADD_REQUEST,
});

export const wishlistAddSuccess = (item) => ({
    type: WISHLIST_ADD_SUCCESS,
    payload: item,
});

export const wishlistAddFailure = (error) => ({
    type: WISHLIST_ADD_FAILURE,
    payload: error,
});

export const wishlistRemoveRequest = () => ({
    type: WISHLIST_REMOVE_REQUEST,
});

export const wishlistRemoveSuccess = (itemId) => ({
    type: WISHLIST_REMOVE_SUCCESS,
    payload: itemId,
});

export const wishlistRemoveFailure = (error) => ({
    type: WISHLIST_REMOVE_FAILURE,
    payload: error,
});

export const wishlistClear = () => ({
    type: WISHLIST_CLEAR,
});


export const addtoCart=(object)=> async (dispatch) => {
    try {
        const res = await axiosInstance.post('cart/add',object);
        if (res.data.code === 1) {
            return {message: "Added to Cart", success: true};
        }
        return {message: "Failed to add", success: false};
    } catch (error) {
        console.log(error)
    }
}

// Thunk Action Creators
export const fetchWishlist = () =>
    async (dispatch) => {
        try {
            dispatch(wishlistListRequest());
            const response = await axiosInstance.get('product/wishlist');
            console.log("WISHLIST",response.data)
            const responseData = response.data;

            dispatch(wishlistListSuccess(responseData.data));
        } catch (error) {
            console.log(error);
            let errorMessage = 'Failed to fetch wishlist items';

            if (error instanceof Error) {
                errorMessage = error.message;
            }

            dispatch(wishlistListFailure(errorMessage));
        }
    };

export const addToWishlist = (productId) =>
    async (dispatch) => {
        try {
            dispatch(wishlistAddRequest());

            const response = await axiosInstance.post('wishlist/add', {
                product_id: productId
            });

            const newItem = response.data.data;
            dispatch(wishlistAddSuccess(newItem));
        } catch (error) {
            console.log(error);
            let errorMessage = 'Failed to add item to wishlist';

            if (error instanceof Error) {
                errorMessage = error.message;
            }

            dispatch(wishlistAddFailure(errorMessage));
        }
    };

export const removeFromWishlist = (id) =>
    async (dispatch) => {
        try {
            const object={
                "product_id":id
            }
            dispatch(wishlistRemoveRequest());

            await axiosInstance.post(`product/wishlist/remove/`,object);

            dispatch(wishlistRemoveSuccess(id));
        } catch (error) {
            console.log(error);
            let errorMessage = 'Failed to remove item from wishlist';

            if (error instanceof Error) {
                errorMessage = error.message;
            }

            dispatch(wishlistRemoveFailure(errorMessage));
        }
    };

export const clearWishlist = () =>
    async (dispatch) => {
        try {
            await axiosInstance.delete('wishlist/clear');

            dispatch(wishlistClear());
        } catch (error) {
            console.log(error);
            // If the clear fails, we should refresh the wishlist
            dispatch(fetchWishlist());
        }
    };

// Initial State
const initialState = {
    loading: false,
    items: [],
    error: null,
    addingToWishlist: false,
    removingFromWishlist: false
};

// Reducer
const wishlistReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case WISHLIST_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case WISHLIST_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.payload,
                error: null
            };

        case WISHLIST_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case WISHLIST_ADD_REQUEST:
            return {
                ...state,
                addingToWishlist: true,
                error: null
            };

        case WISHLIST_ADD_SUCCESS:
            // Check if item already exists
            if (state.items.some(item => item.id === action.payload.id)) {
                return {
                    ...state,
                    addingToWishlist: false
                };
            }

            return {
                ...state,
                addingToWishlist: false,
                items: [...state.items, action.payload],
                error: null
            };

        case WISHLIST_ADD_FAILURE:
            return {
                ...state,
                addingToWishlist: false,
                error: action.payload
            };

        case WISHLIST_REMOVE_REQUEST:
            return {
                ...state,
                removingFromWishlist: true,
                error: null
            };

        case WISHLIST_REMOVE_SUCCESS:
            return {
                ...state,
                removingFromWishlist: false,
                items: state.items.filter(item => item.id !== action.payload),
                error: null
            };

        case WISHLIST_REMOVE_FAILURE:
            return {
                ...state,
                removingFromWishlist: false,
                error: action.payload
            };

        case WISHLIST_CLEAR:
            return {
                ...state,
                items: []
            };

        default:
            return state;
    }
};

export default wishlistReducer;